<template>
  <Head :title="__('vip-order-business.meta.title')">
    <meta
      name="description"
      :content="__('vip-order-business.meta.description')"
    >
    <link
      rel="canonical"
      :href="localeRoute('frontend.vips.order-business.index', [vip])"
    >
    <meta
      property="og:image"
      content="/frontend/assets/favicon/og-image.jpg"
    >
  </Head>

  <section class="order-2">
    <div class="md:container">
      <form @submit.prevent="submit">
        <Link :href="localeRoute('frontend.index')">
          <img
            src="/frontend/assets/logo.svg"
            class="mt-10 hidden lg:block mx-auto"
          >
        </Link>

        <div class="bg-white lg:mt-10 lg:rounded-2xl px-5 py-7 lg:px-20 lg:py-10 lg:w-4/5 lg:mx-auto">
          <div class="w-full">
            <div class="text-center border-b border-gray-100 pb-4 lg:w-1/2 lg:mx-auto">
              <span class="border border-red px-2 text-xl font-bold mx-auto text-red rounded-md mb-2 inline-block">
                {{ __('vip-order-business.tag') }}
              </span>

              <h1 class="text-2xl font-bold">
                {{ __('vip-order-business.title') }}
              </h1>

              <span class="text-xl block">
                {{ __('vip-order-business.title', {vip: vip.content.display_name}) }}
              </span>
            </div>
          </div>

          <div class="w-full mt-4 grid grid-cols-1 gap-4 md:gap-6 lg:mt-8">
            <div class="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6 ">
              <div>
                <InputField
                  v-model="form.for"
                  :form="form"
                  classes="border"
                  name="for"
                  type="text"
                  :label="__('vip-order-business.form.for.text')"
                  :placeholder="__('vip-order-business.form.for.placeholder')"
                  maxlength="255"
                />
              </div>

              <div>
                <InputField
                  v-model="form.email"
                  :form="form"
                  classes="border"
                  name="email"
                  type="email"
                  :label="__('vip-order-business.form.email.text')"
                  :placeholder="__('vip-order-business.form.email.placeholder')"
                  maxlength="255"
                />
              </div>
            </div>

            <div>
              <InputField
                v-model="form.phone"
                :form="form"
                classes="border"
                name="phone"
                type="tel"
                :label="__('vip-order-business.form.phone.text')"
                :placeholder="__('vip-order-business.form.phone.placeholder')"
                maxlength="255"
                :is-required="false"
              />
            </div>

            <div class="relative">
              <TextareaField
                v-model="form.message"
                :form="form"
                classes="border"
                :label="__('vip-order-business.form.message.text')"
                :max-length="300"
                name="message"
                rows="8"
              />
            </div>

            <div class="w-full lg:text-center">
              <button
                type="submit"
                class="button-green shadow-button-black w-full block lg:w-auto lg:inline-block lg:px-16"
              >
                {{ __('vip-order-business.form.submit') }}
                <img
                  src="/frontend/assets/white-arrow.svg"
                  class="inline ml-2"
                >
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </section>
</template>

<script>
import { reactive } from 'vue';
import Clean from '../../../Layout/Clean.vue';
import InputField from '../../../Components/Form/InputField.vue';
import TextareaField from '../../../Components/Form/TextareaField.vue';

export default {
  components: {InputField, TextareaField},

  layout: Clean,

  props: {
    vip: {
      type: Object,
      required: true,
    },
  },

  setup () {
    const form = reactive({
      for: '',
      email: '',
      phone: '',
      message: '',
    });

    return {form};
  },

  methods: {
    submit() {
      this.$inertia.post(this.localeRoute('frontend.vips.order-business.order', this.vip), this.form);
    },
  },
};
</script>
